import createVueComponent from '../createVueComponent';

const ArrowUp = createVueComponent('ArrowUpIcon', [
  ['path', { d: 'm5 12 7-7 7 7', key: 'hav0vg' }],
  ['path', { d: 'M12 19V5', key: 'x0mq9r' }],
]);

export default ArrowUp;
